import { render } from "./FactureXDashboardView.vue?vue&type=template&id=2e12fadb&scoped=true"
import script from "./FactureXDashboardView.vue?vue&type=script&lang=js"
export * from "./FactureXDashboardView.vue?vue&type=script&lang=js"

import "./FactureXDashboardView.vue?vue&type=style&index=0&id=2e12fadb&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e12fadb"]])

export default __exports__